module.exports = __webpack_public_path__ + "img/socials_twitter.815f723e.svg";